import { render } from "./CustomerTable.vue?vue&type=template&id=8dbe4ecc&scoped=true"
import script from "./CustomerTable.vue?vue&type=script&lang=js"
export * from "./CustomerTable.vue?vue&type=script&lang=js"

import "./CustomerTable.vue?vue&type=style&index=0&id=8dbe4ecc&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbe4ecc"]])

export default __exports__